import{commonjsGlobal as e}from"../../_virtual/_commonjsHelpers.js";var o="object"==typeof e&&e&&e.Object===Object&&e;export{o as _};
//# sourceMappingURL=_freeGlobal.js.map
